import React from "react"
import { useQuery } from "urql"

import LoadingSpinner from "../../shared/LoadingSpinner"
import { AnimatedModal } from "../../shared/Modal"

const DEFAULT_PAYMENT_METHOD_QUERY = `
  query($clientId: ID, $userId: ID, $practiceId: ID!) {
    defaultPaymentMethodPractice(clientId: $clientId, userId: $userId, practiceId: $practiceId) {
      brand
      last4
      expMonth
      expYear
    }
  }
`

const ConfirmMissingCardModal = ({
  visible,
  hideModal,
  onSave,
  client,
  amount,
  disabled,
  practice,
  bookingKind = "appointment"
}) => {
  const clientId = client?.__typename === "Client" ? client?.id : null
  const userId = client?.__typename === "User" ? client?.id : null

  const [{ data, fetching, error }] = useQuery({
    query: DEFAULT_PAYMENT_METHOD_QUERY,
    variables: { clientId, userId, practiceId: practice?.id },
    pause: !client?.id || !practice?.hasPaymentProvider
  })

  if (error) console.error(error) // eslint-disable-line no-console

  const cardOnFile = data?.defaultPaymentMethodPractice
  const clientName = client?.firstName || "This client"
  const isPackage = bookingKind === "package"

  return (
    <AnimatedModal
      visible={visible}
      hideModal={hideModal}
      header={cardOnFile ? "Charge card on file now" : "No card on file"}
      showFooter={true}
      actionButtonCopy={cardOnFile ? `Charge ${amount} now` : "Continue & book"}
      actionButtonDataTestid="confirm-missing-card-continue"
      saveDisabled={disabled}
      onSave={onSave}>
      {fetching ? (
        <LoadingSpinner />
      ) : cardOnFile ? (
        <p>
          Booking this {isPackage ? "package" : "appointment"} will charge {clientName}&apos;s card on file (
          {cardOnFile.brand} ending in {cardOnFile.last4}) for {amount}. Click cancel to go back.
        </p>
      ) : (
        <p>
          {clientName} doesn&apos;t have a card on file, but you can still book this{" "}
          {isPackage ? "package" : "appointment"} and add a card later. Use Charge card once a card is saved.
        </p>
      )}
    </AnimatedModal>
  )
}

export default ConfirmMissingCardModal
